import { setAgentConnected } from "store/app/app.actions";
import { MiddlewareStore } from "store/createStore";
import { ChatMessageEvent, IChatMessage } from "store/messages/messages.state";
import { DEFAULT_LANGUAGE } from "translations";

export const handleParticipantLeft = async (message: IChatMessage, store: MiddlewareStore, session: connect.CustomerChatSession): Promise<IChatMessage> => {
    if (message.contentType !== ChatMessageEvent.PARTICIPANT_LEFT) return message;

    const { language, instanceID, systemEndedMessage, appTextTranslations } = store.getState().app;

    if (message.role === "AGENT") {
        store.dispatch(setAgentConnected(false));
        
        const attributes = await window.bchat.getContactAttributes({
            contactId: session.getChatDetails().contactId,
            instanceId: instanceID
        });
    
        if (attributes["sa-system-ended"] === 'true') {
            message.content = systemEndedMessage?.[language]
                ?? (appTextTranslations?.systemEndedMessage?.[language] ?? appTextTranslations?.systemEndedMessage?.[DEFAULT_LANGUAGE])!
        }
    }



    return message

}